// extracted by mini-css-extract-plugin
export default {"deleteIcon":"BZRIdentityInfo_deleteIcon__V9-zt"};